var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useRef } from 'react';
import styled from '../../styled';
const EllipsisTextUI = styled.span `
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  margin: 0;
  @supports (-webkit-line-clamp: 2) {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: initial;
    display: -webkit-box;
    -webkit-line-clamp: ${({ lineClamp }) => lineClamp || 2};
    -webkit-box-orient: vertical;
    word-break: break-word;
  }
`;
const EllipsisText = (_a) => {
    var { text, shouldShowTooltip } = _a, rest = __rest(_a, ["text", "shouldShowTooltip"]);
    const textRef = useRef(null);
    const onMouseEnter = () => {
        if (textRef.current && shouldShowTooltip) {
            const isOverflow = textRef.current.scrollWidth > textRef.current.clientWidth ||
                textRef.current.scrollHeight > textRef.current.clientHeight;
            textRef.current.title = isOverflow ? text : '';
        }
    };
    return (React.createElement(EllipsisTextUI, Object.assign({ ref: textRef }, rest, { onMouseEnter: onMouseEnter }), text));
};
export default React.memo(EllipsisText);
//# sourceMappingURL=index.js.map